module.exports = __webpack_public_path__ + "static/media/yoda-icon.5bb34163.png";